import Character from "../Character";
import WorldbuildingEntry from "../WorldbuildingEntry";
import OutlineBody from "../StoryBible/StructuredOutline/OutlineBody";

type SourceTable = "characters" | "worldbuilding_entries" | "outlines";

type Snapshot = {
  id: string;
  sourceTable: SourceTable;
  data: any;
};

type Props = {
  snapshot: Snapshot | null | undefined;
  projectId?: string;
};

// to appease the typescript gods
const characterNoOps = {
  dragListeners: {},
  isDragging: false,
  setActivatorNodeRef: () => {},
  draggingLock: false,
  isSelected: false,
  handleSelect: () => {},
  onDeleteMultiple: () => {},
  isDeleting: false,
  selectedItems: [],
};

const worldbuildingEntryNoOps = {
  draggingId: null,
  handleDeleteEntry: () => {},
  handleDeleteEntries: () => {},
  selectedItems: [],
  handleSaveEntry: () => {},
  loading: false,
  toggleEntryCollapsed: () => {},
  restoreSnapshot: () => {},
  isRestoring: false,
  regenerateTrait: () => {},
  isSelected: false,
  handleSelect: () => {},
};

const outlineNoOps = {
  projectId: null,
  reorderItem: () => {},
};

export default function HistorySelectedItem({ snapshot, projectId }: Props) {
  if (!snapshot) return null;

  if (snapshot.sourceTable === "characters") {
    return (
      <Character
        readOnly
        initialCharacter={snapshot.data}
        projectId={projectId}
        updateCharacterData={() => {}}
        {...characterNoOps}
      />
    );
  }

  if (snapshot.sourceTable === "worldbuilding_entries") {
    return (
      <WorldbuildingEntry
        entry={snapshot.data}
        readOnly
        customDefaults={[]}
        derivedRoles={[]}
        {...worldbuildingEntryNoOps}
      />
    );
  }

  if (snapshot.sourceTable === "outlines") {
    return (
      <OutlineBody
        readOnly
        outline={snapshot.data}
        {...outlineNoOps}
      />
    );
  }

  return null;
}
